import $i18n from '@alife/panda-i18n';
/**
 * @description 容器操作类型
 */
const CONTAINER_OPERATE_TYPE = [
  {
    label: $i18n.get({ id: 'ModifyInTransit.four_px', dm: '修改在途' }),
    value: 'T',
  },

  {
    label: $i18n.get({ id: 'ReceiptUpperShelf.four_px', dm: '收货上架' }),
    value: 'P',
  },

  {
    label: $i18n.get({ id: 'JH.Picking.four_px', dm: '拣货' }),
    value: 'K',
  },

  {
    label: $i18n.get({ id: 'Distribution.four_px', dm: '配货' }),
    value: 'A',
  },

  {
    label: $i18n.get({ id: 'DB.Packaging.four_px', dm: '打包' }),
    value: 'B',
  },

  {
    label: $i18n.get({ id: 'CheckOut.four_px', dm: '签出' }),
    value: 'S',
  },

  {
    label: $i18n.get({ id: 'RemoveStorageFromShelf.four_px', dm: '移库下架' }),
    value: 'D',
  },

  {
    label: $i18n.get({ id: 'YKSJ.StorageAndShelving.four_px', dm: '移库上架' }),
    value: 'U',
  },

  {
    label: $i18n.get({ id: 'TZKCS.AdjustInventory.four_px', dm: '调整库存数' }),
    value: 'J',
  },
];

/**
 * @description 容器(库位)类型
 */
const GOODS_CONTAINER_TYPE = [
  {
    label: $i18n.get({ id: 'Shelf.four_px', dm: '货架' }),
    value: 'L',
  },

  // {
  //   label: $i18n.get({ id: 'ShippingCrate.four_px', dm: '周转箱' }),
  //   value: 'T',
  // },

  {
    label: $i18n.get({ id: 'ReceivingFrame.four_px', dm: '收货框' }),
    value: 'T',
  },

  {
    label: $i18n.get({ id: 'PickingFrame.four_px', dm: '拣货框' }),
    value: 'B',
  },

  {
    label: $i18n.get({ id: 'DistributionWall.four_px', dm: '配货墙' }),
    value: 'W',
  },

  {
    label: $i18n.get({ id: 'DaBaoTai.four_px', dm: '打包台' }),
    value: 'P',
  },

  {
    label: $i18n.get({ id: 'AgvContainerShelf.four_px', dm: 'AGV容器货架' }),
    value: 'A',
  },

  {
    label: $i18n.get({ id: 'TransferCase.four_px', dm: '移库周转箱' }),
    value: 'M',
  },

  {
    label: $i18n.get({ id: 'LongChe.four_px', dm: '笼车' }),
    value: 'C',
  },

  {
    label: $i18n.get({ id: 'ReplenishmentTurnoverBox.four_px', dm: '补货周转箱' }),
    value: 'R',
  },

  {
    label: $i18n.get({ id: 'ReturnReceiptBox', dm: '退件收货框' }),
    value: 'E',
  },
  {
    label: $i18n.get({ id: 'Subcontainer', dm: '一分容器' }),
    value: 'O',
  },
  {
    label: $i18n.get({ id: 'GoodsCollection', dm: '集货' }),
    value: 'CS',
  },
];

/**
 * @description 是/否
 */
const Y_N = [
  {
    label: $i18n.get({ id: 'Is.four_px', dm: '是' }),
    value: 'Y',
  },

  {
    label: $i18n.get({ id: 'F.No.four_px', dm: '否' }),
    value: 'N',
  },
];

/**
 * @description 是/否
 */
const TRUE_FALSE = [
  {
    label: $i18n.get({ id: 'Is.four_px', dm: '是' }),
    value: true,
  },

  {
    label: $i18n.get({ id: 'F.No.four_px', dm: '否' }),
    value: false,
  },
];

// 999虚拟库位确认差异可选调整原因列表
const VIRTUAL_LOC_ADJ_REASON_LIST = [
  {
    label: $i18n.get({ id: 'WarehouseLiabilityReceivingVaria_286595969', dm: '仓责-收货差异/破损' }),
    value: 'WR',
  },
  // {
  //   label: $i18n.get({ id: 'WarehouseLiabilityReplenishmentV_1828676005', dm: '仓责-补货差异/破损' }),
  //   value: 'RR',
  // },
  // {
  //   label: $i18n.get({ id: 'WarehouseLiabilityPackingVarianc_886382518', dm: '仓责-打包差异/破损' }),
  //   value: 'PA',
  // },
  // {
  //   label: $i18n.get({ id: 'WarehouseResponsibilityCountVari_1307745781', dm: '仓责-盘点差异/破损' }),
  //   value: 'IN',
  // },
  {
    label: $i18n.get({ id: 'WarehouseResponsibilityLibraryLi_2017727039', dm: '仓责-库内环节' }),
    value: 'UN',
  },

  {
    label: $i18n.get({ id: 'CainiaoOther', dm: '菜鸟责-其他' }),
    value: 'CO',
  },
  // {
  //   label: $i18n.get({ id: 'MerchantReasonwrongArrivalCustom_1427786463', dm: '商家原因-到货错误，客户同意无责调整' }),
  //   value: 'AR',
  // },

  // {
  //   label: $i18n.get({ id: 'MerchantTrayPackageConsumables', dm: '商家托盘/包耗材' }),
  //   value: 'MP',
  // },
  // {
  //   label: $i18n.get({ id: 'MerchantReasonSameMerchantDiffer_2092907747', dm: '商家原因-同商家不同货主转换' }),
  //   value: 'MT',
  // },
  // {
  //   label: $i18n.get({ id: 'MerchantReasonOtherCustomerAgree_1103298838', dm: '商家原因-其他，客户同意无责调整' }),
  //   value: 'OO',
  // },
  {
    label: $i18n.get({
      id: 'MerchantReasonCustomerAgreesNoRe_139163336',
      dm: '商家原因-客户同意无责调整',
    }),
    value: 'ML',
  },
  {
    label: $i18n.get({ id: 'TestInventory', dm: '测试库存' }),
    value: 'TI',
  },
];

// 调整原因
const STOCK_QUALITYS = [
  {
    label: $i18n.get({ id: 'Return.four_px', dm: '退货' }),
    value: 'R',
  },

  {
    label: $i18n.get({ id: 'Transfer.four_px', dm: '转货' }),
    value: 'T',
  },

  {
    label: $i18n.get({ id: 'OperationError.four_px', dm: '操作错误' }),
    value: 'O',
  },

  {
    label: $i18n.get({ id: 'LossCompensation.four_px', dm: '丢货赔付' }),
    value: 'M',
  },

  {
    label: $i18n.get({ id: 'InventoryRestoration.four_px', dm: '库存还原' }),
    value: 'B',
  },

  {
    label: $i18n.get({ id: 'ConfirmMissing.four_px', dm: '确认丢失' }),
    value: 'P',
  },

  {
    label: $i18n.get({ id: 'PickingOutOfStock.four_px', dm: '拣货缺货' }),
    value: 'K',
  },

  {
    label: $i18n.get({ id: 'PickingOutOfStock.four_px', dm: '拣货缺货' }),
    value: 'KM',
  },

  {
    label: $i18n.get({ id: 'AbnormalDiskLoss.four_px', dm: '盘亏转异常' }),
    value: 'E',
  },

  {
    label: $i18n.get({ id: 'InventoryShortage.four_px', dm: '盘亏' }),
    value: 'D',
  },

  {
    label: $i18n.get({ id: 'PY.InventorySurplus.four_px', dm: '盘盈' }),
    value: 'A',
  },

  {
    label: $i18n.get({ id: 'ChangeInventoryDifference.four_px', dm: '盘点差异修改' }),
    value: 'U',
  },

  {
    label: $i18n.get({ id: 'PY.InventorySurplus.four_px', dm: '盘盈' }),
    value: 'I',
  },

  {
    label: $i18n.get({ id: 'InventoryShortage.four_px', dm: '盘亏' }),
    value: 'L',
  },

  {
    label: $i18n.get({ id: 'SwitchFromSurplusToAvailable.four_px', dm: '盘盈转可用' }),
    value: 'S',
  },

  {
    label: $i18n.get({ id: 'InventoryRestoration.four_px', dm: '库存还原' }),
    value: 'B',
  },

  {
    label: $i18n.get({ id: 'VasDestruction.four_px', dm: 'vas销毁' }),
    value: 'V',
  },

  {
    label: $i18n.get({ id: 'HuanBiao.four_px', dm: '换标' }),
    value: 'C',
  },

  {
    label: $i18n.get({ id: 'C88Adjustment.four_px', dm: 'C88调整' }),
    value: 'G',
  },

  {
    label: $i18n.get({ id: 'NewInventorySurplus.four_px', dm: '新增盘盈' }),
    value: 'N',
  },

  {
    label: $i18n.get({ id: 'AdjustQuality.four_px', dm: '调整质量' }),
    value: 'Y',
  },

  {
    label: $i18n.get({ id: 'C88Freeze.four_px', dm: 'C88冻结' }),
    value: 'CL',
  },

  {
    label: $i18n.get({ id: 'C88Thaw.four_px', dm: 'C88解冻' }),
    value: 'CU',
  },

  {
    label: $i18n.get({ id: 'VasLocking.four_px', dm: 'VAS锁定' }),
    value: 'VL',
  },

  {
    label: $i18n.get({ id: 'VasUnlock.four_px', dm: 'VAS解锁' }),
    value: 'VU',
  },

  {
    label: `AVG${$i18n.get({ id: 'PickingOutOfStock.four_px', dm: '拣货缺货' })}`,
    value: 'AK',
  },

  {
    label: `AGV${$i18n.get({ id: 'Count.four_px', dm: '盘点' })}`,
    value: 'AT',
  },

  {
    label: `AGV${$i18n.get({ id: 'ExceptionRecovery.four_px', dm: '异常还原' })}`,
    value: 'AB',
  },

  {
    label: `AGV${$i18n.get({ id: 'ConfirmMissing.four_px', dm: '确认丢失' })}`,
    value: 'AP',
  },

  {
    label: `AGV${$i18n.get({ id: 'InventoryAdjustment.four_px', dm: '库存调整' })}`,
    value: 'AA',
  },

  {
    label: `AGV${$i18n.get({ id: 'KWTZ.LocationAdjustment.four_px', dm: '库位调整' })}`,
    value: 'AL',
  },

  {
    label: $i18n.get({ id: 'UnlockInventory.four_px', dm: '库存解锁' }),
    value: 'AU',
  },

  {
    label: $i18n.get({ id: 'SwitchAgvToManual.four_px', dm: 'AGV转人工' }),
    value: 'AH',
  },

  {
    label: $i18n.get({ id: 'MoreGoods.four_px', dm: '来货多货' }),
    value: 'WS',
  },

  {
    label: $i18n.get({ id: 'SpecialReason.four_px', dm: '特殊原因' }),
    value: 'WO',
  },

  {
    label: $i18n.get({ id: 'DeliveryErrorTransfer.four_px', dm: '到货错误（转货）' }),
    value: 'WT',
  },

  {
    label: $i18n.get({ id: 'DeductionAndCompensation.four_px', dm: '抵扣赔付' }),
    value: 'WM',
  },

  {
    label: $i18n.get({ id: 'ShortArrival.four_px', dm: '到货短少' }),
    value: 'WB',
  },

  {
    label: $i18n.get({ id: 'DamagedUponArrival.four_px', dm: '到货破损' }),
    value: 'WD',
  },

  {
    label: $i18n.get({ id: 'TagError.four_px', dm: '标签错误' }),
    value: 'WL',
  },

  {
    label: $i18n.get({ id: 'DamagedOperation.four_px', dm: '作业破损' }),
    value: 'WJ',
  },

  {
    label: $i18n.get({ id: 'TheftInTheLibrary.four_px', dm: '库内偷盗' }),
    value: 'WE',
  },

  {
    label: $i18n.get({ id: 'InternalFire.four_px', dm: '库内火灾' }),
    value: 'WF',
  },

  {
    label: $i18n.get({ id: 'InfringementInvestigation.four_px', dm: '侵权调查' }),
    value: 'WI',
  },

  {
    label: $i18n.get({ id: 'OverseasInspection.four_px', dm: '海外查验' }),
    value: 'WC',
  },

  {
    label: $i18n.get({ id: 'AdjustTheLocation.four_px', dm: '调整库位' }),
    value: 'MO',
  },

  {
    label: $i18n.get({ id: 'ConfirmMissing.four_px', dm: '确认丢失' }),
    value: 'LO',
  },

  {
    label: $i18n.get({ id: 'InventoryOfMultipleGoods', dm: '盘点多货' }),
    value: 'TA',
  },

  {
    label: $i18n.get({ id: 'InventoryOfGoods', dm: '盘点少货' }),
    value: 'TD',
  },

  {
    label: $i18n.get({ id: 'ExtendedDestruction', dm: '超期销毁' }),
    value: 'RD',
  },

  {
    label: $i18n.get({ id: 'TransferAdjustment', dm: '移库调整' }),
    value: 'ME',
  },

  {
    label: $i18n.get({ id: 'LockedInventory.four_px', dm: '锁定库存' }),
    value: 'GL',
  },

  {
    label: $i18n.get({ id: 'UnlockInventory', dm: '解锁库存' }),
    value: 'GU',
  },

  {
    label: $i18n.get({ id: 'MerchantInventorySwitch', dm: '商家库存切换' }),
    value: 'CT',
  },

  {
    label: $i18n.get({ id: 'WarehouseLiabilityReceivingVaria_286595969', dm: '仓责-收货差异/破损' }),
    value: 'RE',
  },
  {
    label: $i18n.get({ id: 'PutawayDiscrepancyDamage.four_px', dm: '上架差异/破损' }),
    value: 'PU',
  },
  {
    label: $i18n.get({ id: 'WarehouseLiabilityReplenishmentV_1828676005', dm: '仓责-补货差异/破损' }),
    value: 'RR',
  },
  {
    label: $i18n.get({ id: 'PickingDiscrepancyDamage.four_px', dm: '拣货差异/破损' }),
    value: 'PI',
  },
  {
    label: $i18n.get({ id: 'WarehouseLiabilityPackingVarianc_886382518', dm: '仓责-打包差异/破损' }),
    value: 'PA',
  },
  {
    label: $i18n.get({ id: 'ReturnDiscrepancyDamage.four_px', dm: '退货差异/破损' }),
    value: 'RG',
  },
  {
    label: $i18n.get({ id: 'ValueAddedDiscrepancyDamage.four_px', dm: '增值差异/破损' }),
    value: 'VA',
  },
  {
    label: $i18n.get({ id: 'WarehouseResponsibilityCountVari_1307745781', dm: '仓责-盘点差异/破损' }),
    value: 'IN',
  },
  {
    label: $i18n.get({ id: 'WarehouseResponsibilityLibraryLi_2017727039', dm: '仓责-库内环节' }),
    value: 'UN',
  },
  {
    label: $i18n.get({ id: 'CainiaoOther', dm: '菜鸟责-其他' }),
    value: 'CO',
  },
  {
    label: $i18n.get({ id: 'NonwarehouseResponsibilitycustom_1500919221', dm: '非仓责-客户到货错误（转货）' }),
    value: 'AR',
  },
  {
    label: $i18n.get({
      id: 'MerchantReasonCustomerAgreesNoRe_139163336',
      dm: '商家原因-客户同意无责调整',
    }),
    value: 'ML',
  },
  {
    label: $i18n.get({ id: 'NonwarehouseResponsibilitymercha_533093517', dm: '非仓责-商家托盘/包耗材' }),
    value: 'MP',
  },
  {
    label: $i18n.get({ id: 'WarehouseLiabilityReceivingVaria_286595969', dm: '仓责-收货差异/破损' }),
    value: 'WR',
  },
  {
    label: $i18n.get({ id: 'NonwarehouseResponsibilitycustom_687812911', dm: '非仓责-客户批量处理（销毁、售卖等）' }),
    value: 'CR',
  },
  {
    label: $i18n.get({ id: 'Find.four_px', dm: '找货新增' }),
    value: 'KL',
  },
  {
    label: $i18n.get({ id: 'TestInventory', dm: '测试库存' }),
    value: 'TI',
  },
  {
    label: $i18n.get({ id: 'MerchantReasons', dm: '商家原因' }),
    value: 'BR',
  },
  {
    label: $i18n.get({ id: '31255237310418944.CNTM', dm: '其他' }),
    value: 'OT',
  },
  {
    label: $i18n.get({ id: 'MerchantReasonOtherCustomerAgree_1103298838', dm: '商家原因-其他，客户同意无责调整' }),
    value: 'OO',
  },
];

// 调整类型
const ADJUSTYPE = [
  {
    label: $i18n.get({ id: 'KCSTZ.InventoryAdjustment.four_px', dm: '库存数调整' }),
    value: 'N',
  },

  {
    label: $i18n.get({ id: 'LocationAdjustment.four_px', dm: '货位调整' }),
    value: 'L',
  },
];

// 差异类型
const DIFFTYPE = [
  {
    label: $i18n.get({ id: 'MultipleGoods', dm: '多货' }),
    value: 'excell',
  },

  {
    label: $i18n.get({ id: 'LessGoods', dm: '少货' }),
    value: 'shortage',
  },
];

// 差异单状态
const INVDIFFERENTJOBSTATUS = [
  {
    label: $i18n.get({ id: 'Pending.four_px', dm: '待处理' }),
    value: 'PENDING',
  },
  {
    label: $i18n.get({ id: 'ToBeVerified.four_px', dm: '待核实' }),
    value: 'PENDING_CONFIRE',
  },

  {
    label: $i18n.get({ id: 'PendingReview.four_px', dm: '待审核' }),
    value: 'UNDER_REVIEW',
  },
  {
    label: $i18n.get({ id: 'Rejected.YObEl', dm: '已驳回' }),
    value: 'REJECT_REVIEW',
  },

  {
    label: $i18n.get({ id: 'Closed.four_px', dm: '已完结' }),
    value: 'COMPLETE',
  },
  {
    label: $i18n.get({ id: 'AdjustmentFailed', dm: '调整失败' }),
    value: 'FAIL',
  },
];

// 来源业务类型
const DIFFERENTJOBBUSINESSTYPE = [
  {
    label: $i18n.get({ id: 'JH.Picking.four_px', dm: '拣货' }),
    value: 'pick',
  },
  {
    label: $i18n.get({ id: 'Sorting.four_px', dm: '分拣' }),
    value: 'transfer',
  },
  {
    label: $i18n.get({ id: 'DB.Packaging.four_px', dm: '打包' }),
    value: 'pack',
  },
  {
    label: $i18n.get({ id: 'Count.four_px', dm: '盘点' }),
    value: 'TAKESTOCK',
  },
  {
    label: $i18n.get({ id: 'Transit.four_px', dm: '移库' }),
    value: 'MOVE',
  },
  {
    label: $i18n.get({ id: 'Find.four_px', dm: '找货新增' }),
    value: 'find',
  },
  {
    label: $i18n.get({ id: 'Replenishment.four_px', dm: '补货' }),
    value: 'RP',
  },
];

// 操作环节
const OPERATIONSTEP = [
  {
    label: $i18n.get({ id: 'VarianceInventoryAdjustment', dm: '差异库存调整' }),
    value: 'ADJUST',
  },
  {
    label: $i18n.get({ id: 'VarianceAdded', dm: '差异新增' }),
    value: 'DIFF_ADD',
  },

  {
    label: $i18n.get({ id: 'DiscrepancyProcessing', dm: '差异处理' }),
    value: 'DIFF_DEAL',
  },

  {
    label: $i18n.get({ id: 'VarianceReview', dm: '差异审核' }),
    value: 'DIFF_REVIEW',
  },
];

// 差异单操作类型
const TYPE = [
  {
    label: $i18n.get({ id: 'Add.four_px', dm: '新增' }),
    value: 'add',
  },
  {
    label: $i18n.get({ id: 'Retrieve.8HAn0', dm: '找回' }),
    value: 'FIND',
  },
  {
    label: $i18n.get({ id: 'Lost.four_px', dm: '丢失' }),
    value: 'LOSS',
  },
  {
    label: $i18n.get({ id: 'ReviewStart', dm: '审核开始' }),
    value: 'START',
  },
  {
    label: $i18n.get({ id: 'Approved', dm: '审核通过' }),
    value: 'DIFF_APROVIE',
  },
  {
    label: $i18n.get({ id: 'Rejected', dm: '审核拒绝' }),
    value: 'DIFF_REFUSE',
  },
  {
    label: $i18n.get({ id: 'InventoryAdjustment.four_px', dm: '库存调整' }),
    value: 'ADJUST',
  },
  {
    label: $i18n.get({ id: 'Rejected', dm: '审核拒绝' }),
    value: 'REFUSE',
  },
  {
    label: $i18n.get({ id: 'Approved', dm: '审核通过' }),
    value: 'APROVIE',
  },
];

// 异常库存类型

const STOCKTYPE = [
  {
    label: $i18n.get({ id: 'AvailableInventory.four_px', dm: '可用库存' }),
    value: 'A',
  },

  {
    label: $i18n.get({ id: 'LockedInventory.four_px', dm: '锁定库存' }),
    value: 'K',
  },

  {
    label: $i18n.get({ id: 'PendingInventory.four_px', dm: '待出库存' }),
    value: 'P',
  },

  {
    label: $i18n.get({ id: 'AbnormalInventory.four_px', dm: '异常库存' }),
    value: 'E',
  },

  {
    label: $i18n.get({ id: 'TZKCS.AdjustInventory.four_px', dm: '调整库存数' }),
    value: 'J',
  },

  {
    label: $i18n.get({ id: 'InventoryRestoration.four_px', dm: '库存还原' }),
    value: 'B',
  },
];

// 库存类型数量范围筛选

const INVENORYNUMTYPE = [
  {
    label: $i18n.get({ id: 'Inventory.four_px', dm: '库位库存' }),
    value: '1',
  },

  {
    label: $i18n.get({ id: 'LockedInventory.four_px', dm: '锁定库存' }),
    value: '2',
  },

  {
    label: $i18n.get({ id: 'InventoryToBeReleased.four_px', dm: '待出库库存' }),
    value: '3',
  },

  {
    label: $i18n.get({ id: 'AbnormalInventory.four_px', dm: '异常库存' }),
    value: '4',
  },

  {
    label: $i18n.get({ id: 'AvailableInventory.four_px', dm: '可用库存' }),
    value: '5',
  },
];

/**
 * 库存查询
 */
// 调整类型
const STOCK_SEARCH_ADJUST_TYPE = [
  // {
  //   label: $i18n.get({ id: 'IncreaseInventory.four_px', dm: '增加库存' }),
  //   value: 'ADD',
  // },
  {
    label: $i18n.get({ id: 'ReduceRMAInventory.four_px', dm: '删减RMA库存' }),
    value: 'SUB_RMA',
  },
];

// 调整原因 --- 增加
const STOCK_SEARCH_ADJUST_ADD_RESON = [
  {
    label: $i18n.get({ id: 'DeductionAndCompensation.four_px', dm: '抵扣赔付' }),
    value: 'WM',
    detail: $i18n.get({
      id: 'RefersToTheGoodsThatHave_3686940992.four_px',
      dm: '指已赔付的商品现在找回，且客户同意抵扣，故添加库存',
    }),
  },
  {
    label: $i18n.get({ id: 'MerchantReasons', dm: '商家原因' }),
    value: 'BR',
  },
  {
    label: $i18n.get({ id: '31255237310418944.CNTM', dm: '其他' }),
    value: 'OT',
  },
];

// 调整原因 --- 删减RMA
const STOCK_SEARCH_ADJUST_SUB_RMA_RESON = [
  // {
  //   label: $i18n.get({ id: 'NonwarehouseResponsibilitycustom_687812911', dm: '非仓责-客户批量处理（销毁、售卖等）' }),
  //   value: 'CR',
  // },
  // {
  //   label: $i18n.get({
  //     id: 'NonwarehouseResponsibilitywareho_1750551241',
  //     dm: '非仓责-仓库原因（客户同意调整无需赔付）',
  //   }),
  //   value: 'ML',
  // },
  {
    label: $i18n.get({ id: 'WarehouseLiabilityReceivingVaria_286595969', dm: '仓责-收货差异/破损' }),
    value: 'WR',
  },
  {
    label: $i18n.get({ id: 'MerchantReasonCustomerAgreesNoRe_139163336', dm: '商家原因-客户同意无责调整' }),
    value: 'OO',
  },
];

// 调整原因 --- 扣减
const STOCK_SEARCH_ADJUST_SUB_RESON = [
  {
    label: $i18n.get({ id: 'DeliveryErrorTransfer.four_px', dm: '到货错误（转货）' }),
    value: 'WT',
    detail: $i18n.get({
      id: 'RefersToTheCustomerArrivalError_3148150007.four_px',
      dm: '指客户到货错误，预报A实际到货B，但B已经上架；需要调减A库存',
    }),
  },

  {
    label: $i18n.get({ id: 'ShortArrival.four_px', dm: '到货短少' }),
    value: 'WB',
    detail: $i18n.get({
      id: 'ItRefersToTheDifferenceBetween_2624512561.four_px',
      dm: '指仓库上架后才发现客户来货短少的差异，经客户同意调整库存',
    }),
  },

  {
    label: $i18n.get({ id: 'DamagedUponArrival.four_px', dm: '到货破损' }),
    value: 'WD',
    detail: $i18n.get({
      id: 'RefersToTheDifferenceThatThe_1847416681.four_px',
      dm: '指仓库上架后才发现客户来货破损的差异，经客户同意调整库存',
    }),
  },

  {
    label: $i18n.get({ id: 'TagError.four_px', dm: '标签错误' }),
    value: 'WL',
    detail: $i18n.get({
      id: 'ItRefersToTheFactThat_2159588293.four_px',
      dm: '指仓库上架后才发现客户来货标签错误，经客户同意调整库存',
    }),
  },

  {
    label: $i18n.get({ id: 'DamagedOperation.four_px', dm: '作业破损' }),
    value: 'WJ',
    detail: $i18n.get({
      id: 'RefersToTheDamageOfGoods_1636915872.four_px',
      dm: '指因不规范作业导致的商品破损，需要调整库存',
    }),
  },

  {
    label: $i18n.get({ id: 'TheftInTheLibrary.four_px', dm: '库内偷盗' }),
    value: 'WE',
    detail: $i18n.get({ id: 'RefersToTheLossOfGoods_2362234210.four_px', dm: '指因偷盗导致的货物丢失，需要调整库存' }),
  },

  {
    label: $i18n.get({ id: 'InternalFire.four_px', dm: '库内火灾' }),
    value: 'WF',
    detail: $i18n.get({ id: 'RefersToTheDamageOfGoods_82958457.four_px', dm: '指因火灾导致货物损坏，需要调整库存' }),
  },

  {
    label: $i18n.get({ id: 'InfringementInvestigation.four_px', dm: '侵权调查' }),
    value: 'WI',
    detail: $i18n.get({
      id: 'RefersToTheInfringementInvestigationInitiated_2605917457.four_px',
      dm: '指我司发起侵权调查，需要拆包查验',
    }),
  },

  {
    label: $i18n.get({ id: 'OverseasInspection.four_px', dm: '海外查验' }),
    value: 'WC',
    detail: $i18n.get({
      id: 'ItMeansThatTheGoodsCannot_2217034851.four_px',
      dm: '指商品被海关查验导致出现损坏不能售卖，需要调整库存',
    }),
  },

  {
    label: $i18n.get({ id: 'SpecialReason.four_px', dm: '特殊原因' }),
    value: 'WO',
    detail: $i18n.get({
      id: 'UseThisOptionToDeleteInventory_1726264807.four_px',
      dm: '通过此项删减库存，请明确描述删减场景',
    }),
  },
];

/**
 * 差异库位管理
 */
// tab
const STOCK_DIFF_MANAGE = [
  {
    label: $i18n.get({ id: '999WarehouseLocationToBeFound.four_px', dm: '999库位待找货' }),
    value: '999',
  },

  {
    label: $i18n.get({ id: '999LocationZhaoHuoOutOf_2665473992.four_px', dm: '999库位找货缺货' }),
    value: '888',
  },
  {
    label: $i18n.get({ id: '999WarehouseInventoryLossApprova_250079496', dm: '999库位盘亏审批' }),
    value: '888_LR',
  },
];

// 异常类型
const STOCK_DIFF_EXCEPTE_TYPE = [
  {
    label: $i18n.get({ id: 'All.four_px', dm: '全部' }),
    value: 'all',
  },

  {
    label: $i18n.get({ id: 'JH.Picking.four_px', dm: '拣货' }),
    value: 'pick',
  },

  {
    label: $i18n.get({ id: 'Sorting.four_px', dm: '分拣' }),
    value: 'transfer',
  },

  {
    label: $i18n.get({ id: 'DB.Packaging.four_px', dm: '打包' }),
    value: 'pack',
  },
  {
    label: $i18n.get({ id: 'Count.four_px', dm: '盘点' }),
    value: 'TAKESTOCK',
  },
  {
    label: $i18n.get({ id: 'Transit.four_px', dm: '移库' }),
    value: 'MOVE',
  },
  {
    label: $i18n.get({ id: 'Find.four_px', dm: '找货新增' }),
    value: 'find',
  },
  {
    label: $i18n.get({ id: 'Replenishment.four_px', dm: '补货' }),
    value: 'RP',
  },
];

// SKU类型
const DIFF_SKU_TYPE = [
  {
    label: $i18n.get({ id: 'SkuEncoding.four_px', dm: 'SKU编码' }),
    value: 'skuCodes',
  },

  {
    label: $i18n.get({ id: 'SKUTM.SkuBarCode.four_px', dm: 'SKU条码' }),
    value: 'productCodeOrSkuIds',
  },
];

// 退件SKU管理
const RETRNSKU_LIST_CONST = [
  {
    label: $i18n.get({ id: 'AvailableInventory.four_px', dm: '可用库存' }),
    value: 'A',
  },

  {
    label: $i18n.get({ id: 'PendingInventory.four_px', dm: '待出库存' }),
    value: 'P',
  },

  {
    label: $i18n.get({ id: 'LockedInventory.four_px', dm: '锁定库存' }),
    value: 'K',
  },

  {
    label: $i18n.get({ id: 'JobInventory', dm: '作业库存' }),
    value: 'J',
  },

  {
    label: $i18n.get({ id: 'AbnormalInventory.four_px', dm: '异常库存' }),
    value: 'E',
  },

  {
    label: $i18n.get({ id: 'DeductInventory', dm: '已扣库存' }),
    value: 'N',
  },

  {
    label: $i18n.get({ id: 'InventoryToBeRestored', dm: '待恢复库存' }),
    value: 'R',
  },

  {
    label: $i18n.get({ id: 'InventoryLoss', dm: '盘亏库存' }),
    value: 'O',
  },

  {
    label: $i18n.get({ id: 'InventorySurplus.four_px', dm: '盘盈库存' }),
    value: 'S',
  },
];

const ATTRIBUTELIST = [
  {
    label: $i18n.get({ id: 'DD.Charged.four_px', dm: '带电' }),
    value: 'battery',
  },

  {
    label: $i18n.get({ id: 'Expensive', dm: '贵品' }),
    value: 'hvg',
  },

  {
    label: $i18n.get({ id: '31255239470485504.CNTM', dm: '批次' }),
    value: 'batch',
  },

  {
    label: $i18n.get({ id: 'EffectivePeriod', dm: '效期' }),
    value: 'expire',
  },
];

const DONGXIAOLVLIST = [
  {
    label: 'A',
    value: 'A',
  },

  {
    label: 'B',
    value: 'B',
  },

  {
    label: 'C',
    value: 'C',
  },

  {
    label: 'D',
    value: 'D',
  },
];

const TWINLIST = [
  {
    label: `${$i18n.get({ id: 'Customer.four_px', dm: '客户' })} ID`,
    value: 'customerIds',
  },

  {
    label: $i18n.get({ id: 'KHBM.CustomerCode.four_px', dm: '客户编码' }),
    value: 'customerCodes',
  },

  {
    label: 'SKU ID',
    value: 'skuIds',
  },

  {
    label: $i18n.get({ id: 'SkuEncoding.four_px', dm: 'SKU编码' }),
    value: 'skuCodes',
  },
];

const DTREECARGOTYPES = [
  {
    label: 'T25',
    value: 'T25',
  },

  {
    label: 'T50',
    value: 'T50',
  },

  {
    label: 'T120',
    value: 'T120',
  },

  {
    label: 'T240',
    value: 'T240',
  },

  {
    label: 'TM',
    value: '5TM',
  },
];

export const ZUOYEDSTREELIST = [
  {
    label: $i18n.get({ id: 'UpperShelf.four_px', dm: '上架' }),
    value: 'PUT_AWAY',
  },

  {
    label: $i18n.get({ id: 'JH.Picking.four_px', dm: '拣货' }),
    value: 'PICK',
  },

  {
    label: $i18n.get({ id: 'DB.Packaging.four_px', dm: '打包' }),
    value: 'PACK',
  },

  {
    label: $i18n.get({ id: 'Count.four_px', dm: '盘点' }),
    value: 'TAKE_STOCK',
  },

  {
    label: $i18n.get({ id: 'Transit.four_px', dm: '移库' }),
    value: 'RELOCATION',
  },

  {
    label: $i18n.get({ id: 'Replenishment.four_px', dm: '补货' }),
    value: 'REPLENISH',
  },
];

const CHECKVIEWLISTPANDA = [
  {
    label: `${$i18n.get({ id: 'SmallShelfArea.four_px', dm: '小货架区' })}E`,
    value: 'SmallShelvesE',
  },

  {
    label: `${$i18n.get({ id: 'SmallShelfArea.four_px', dm: '小货架区' })}D`,
    value: 'SmallShelvesD',
  },

  {
    label: `${$i18n.get({ id: 'SmallShelfArea.four_px', dm: '小货架区' })}F`,
    value: 'SmallShelvesF',
  },

  {
    label: `${$i18n.get({ id: 'HeapArea.four_px', dm: '地堆区' })}H`,
    value: 'Heaps-H',
  },

  {
    label: `${$i18n.get({ id: 'HeapArea.four_px', dm: '地堆区' })}H1`,
    value: 'HeapsOne',
  },

  {
    label: `${$i18n.get({ id: 'GuipinDistrict.four_px', dm: '贵品区' })}G`,
    value: 'precious-G',
  },

  {
    label: `${$i18n.get({ id: 'HighShelfArea.four_px', dm: '高位货架区' })} CP/CS`,
    value: 'HeightShelves CP/CS',
  },

  {
    label: $i18n.get({ id: 'DaBaoTai.four_px', dm: '打包台' }),
    value: 'packShelves',
  },
];

// 货型 S：小货 M：中货 L：大货
const GOODS_CARGO_TYPE = [
  {
    label: 'T25',
    value: 'S',
  },

  {
    label: 'T50',
    value: 'M',
  },

  {
    label: 'T120',
    value: 'L',
  },
  {
    label: 'T240',
    value: 'O',
  },

  {
    label: 'TM',
    value: 'W',
  },
];

// 存储分类：商家贵品/BIZ_PRICEY, 仓库贵品/WH_PRICEY, 空/BLANK
const STORAGE_TYPE = [
  {
    label: $i18n.get({ id: 'MerchantExpensiveProducts', dm: '商家贵品' }),
    value: 'BIZ_PRICEY',
  },

  {
    label: $i18n.get({ id: 'ExpensiveProducts', dm: '仓库贵品' }),
    value: 'WH_PRICEY',
  },

  {
    label: $i18n.get({ id: 'Empty', dm: '空' }),
    value: 'BLANK',
  },
];

const CONTAINWENUMTYPE_LIST = [
  {
    label: $i18n.get({ id: 'ContainerInventory.four_px', dm: '容器库存' }),
    value: 1,
  },

  {
    label: $i18n.get({ id: 'InTransitInventory.four_px', dm: '在途库存' }),
    value: 2,
  },
  {
    label: $i18n.get({ id: 'AbnormalInventory.four_px', dm: '异常库存' }),
    value: 3,
  },
];

const GOODS_TYPE = [
  {
    label: $i18n.get({ id: 'WithForecastSKU', dm: '有预报SKU' }),
    value: 'Y',
  },
  {
    label: $i18n.get({ id: 'ThreeNoProducts', dm: '三无产品' }),
    value: 'N',
  },
];

const QUALITY_TYPE = [
  {
    label: $i18n.get({ id: 'Good.four_px', dm: '良好' }),
    value: 'G',
  },
  {
    label: $i18n.get({ id: 'Damaged.four_px', dm: '破损' }),
    value: 'B',
  },
];

const SKU_TYPE = [
  {
    label: $i18n.get({ id: 'SkuEncoding.four_px', dm: 'SKU编码' }),
    value: 'skuCodes',
  },
  {
    label: $i18n.get({ id: 'SkuBarcode.four_px', dm: 'SKU条码' }),
    value: 'skuIdOrProductCodes',
  },
];

const OPT_TYPE = [
  {
    label: $i18n.get({ id: 'Add.four_px', dm: '新增' }),
    value: 'S',
  },
  {
    label: $i18n.get({ id: 'Modify.four_px', dm: '修改' }),
    value: 'U',
  },
  {
    label: $i18n.get({ id: 'ReturnLibrary', dm: '还库' }),
    value: 'F',
  },
  {
    label: $i18n.get({ id: 'Destruction.four_px', dm: '销毁' }),
    value: 'D',
  },
  {
    label: $i18n.get({ id: 'transfer', dm: '移库' }),
    value: 'M',
  },
];

const PACKAGE_OPT_TYPE = [
  {
    label: $i18n.get({ id: 'Add.four_px', dm: '新增' }),
    value: 'insert',
  },
  {
    label: $i18n.get({ id: 'Modify.four_px', dm: '修改' }),
    value: 'update',
  },
];

export const CHECK_STATUS = [
  {
    label: $i18n.get({ id: 'PendingApproval', dm: '待审批' }),
    value: 'SA',
  },
  {
    label: $i18n.get({ id: 'ToBeChecked', dm: '待查验' }),
    value: 'SN',
  },

  {
    label: $i18n.get({ id: 'InInspection', dm: '查验中' }),
    value: 'SH',
  },
  {
    label: $i18n.get({ id: 'Closed.four_px', dm: '已完结' }),
    value: 'SF',
  },
];

export const CHECK_STATUS_TWO = [
  {
    label: $i18n.get({ id: 'PendingApproval', dm: '待审批' }),
    value: 'SA',
  },
  {
    label: $i18n.get({ id: 'ToBeChecked', dm: '待查验' }),
    value: 'SN',
  },

  {
    label: $i18n.get({ id: 'InInspection', dm: '查验中' }),
    value: 'SH',
  },
  {
    label: $i18n.get({ id: 'Closed.four_px', dm: '已完结' }),
    value: 'SF',
  },
  {
    label: $i18n.get({ id: 'ApprovalCompleted', dm: '审批完结' }),
    value: 'AC',
  },
  {
    label: $i18n.get({ id: 'ManualCompletion', dm: '手动完结' }),
    value: 'MC',
  },
];

const CHECK_REASON = [
  {
    label: $i18n.get({ id: 'CustomerChallenge', dm: '客户挑战' }),
    value: 'C',
  },
  {
    label: $i18n.get({ id: 'QCSelfexamination', dm: 'QC自查' }),
    value: 'Q',
  },
  {
    label: $i18n.get({ id: 'InwarehouseReexamination', dm: '仓内复查' }),
    value: 'R',
  },
  {
    label: $i18n.get({ id: 'SettlementVarianceReview', dm: '结算差异复查' }),
    value: 'S',
  },
];

const CHECK_REASON_SKU = [
  {
    label: $i18n.get({ id: 'CalibrationOfOldProducts', dm: '老品校准' }),
    value: 'O',
  },
  {
    label: $i18n.get({ id: 'NewProductStorage', dm: '新品入库' }),
    value: 'N',
  },
  {
    label: $i18n.get({ id: 'CustomerChallenge', dm: '客户挑战' }),
    value: 'C',
  },
  {
    label: $i18n.get({ id: 'QCSelfexamination', dm: 'QC自查' }),
    value: 'Q',
  },
  {
    label: $i18n.get({ id: 'InwarehouseReexamination', dm: '仓内复查' }),
    value: 'R',
  },
];

// 异常库位库存细分类型
const ABNORMAL_LOCATION_INVENTORY_BREAKDOWN_TYPE = [
  {
    label: $i18n.get({ id: 'PickOutofstockSortingReturnRack', dm: '拣选缺货分拣返架' }),
    value: 'PICK_CONTAINERTRANSFER_RETURN',
  },
  {
    label: $i18n.get({ id: 'PickOutOfStockPackAndReturnTo', dm: '拣选缺货打包返架' }),
    value: 'PICK_PACK_RETURN',
  },
  {
    label: $i18n.get({ id: 'SortingOutOfGoodsSortingReturnRa_1964910330', dm: '分拣缺货分拣返架' }),
    value: 'TRANSFER_LACK_RETURN',
  },
  {
    label: $i18n.get({ id: 'PickAndDivideOutOfStockPackAnd', dm: '边拣边分缺货打包返架' }),
    value: 'PICK_TRANSFER_PACK_RETURN',
  },
  {
    label: $i18n.get({ id: 'PackOutOfStockPackBackToShelf', dm: '打包缺货打包返架' }),
    value: 'PACK_LACK_RETURN',
  },
  {
    label: $i18n.get({ id: 'PackAndInterceptReturnRack', dm: '打包拦截返架' }),
    value: 'PACK_INTERCEPT_RETURN',
  },
  {
    label: $i18n.get({ id: 'ReceiptUpperShelf.four_px', dm: '收货上架' }),
    value: 'P_I',
  },
  {
    label: $i18n.get({ id: 'PickOffTheShelf.four_px', dm: '拣选下架' }),
    value: 'S_O',
  },
  {
    label: $i18n.get({ id: 'YKSJ.StorageAndShelving.four_px', dm: '移库上架' }),
    value: 'M_I',
  },
  {
    label: $i18n.get({ id: 'RemoveStorageFromShelf.four_px', dm: '移库下架' }),
    value: 'M_O',
  },
  {
    label: $i18n.get({ id: 'InventorySurplus', dm: '库存盘盈' }),
    value: 'A_I',
  },
  {
    label: $i18n.get({ id: 'InventoryLoss.Kutoy', dm: '库存盘亏' }),
    value: 'A_O',
  },
  {
    label: $i18n.get({ id: 'ValueAddedOutbound', dm: '增值出库' }),
    value: 'V_O',
  },
  {
    label: $i18n.get({ id: 'ValueAddedWarehousing', dm: '增值入库' }),
    value: 'V_I',
  },
  {
    label: $i18n.get({ id: 'ReturnToShelf', dm: '退货上架' }),
    value: 'GP_I',
  },
  {
    label: $i18n.get({ id: 'QuickPickOutOfStockAndReturnTo', dm: '增值入库' }),
    value: 'PICK_QUICK_RETURN',
  },
  {
    label: $i18n.get({ id: 'PACKETINGlPACKETINGlPACKETINGlPA_985474290', dm: '打包复拣暂存' }),
    value: 'PACK_REPLENISH_PICK_RETURN',
  },
];

const PACKAGE_LAN_TYPE = [
  {
    label: $i18n.get({ id: 'Chinese.four_px', dm: '中文' }),
    value: 'zh',
  },

  {
    label: $i18n.get({ id: 'English.four_px', dm: '英文' }),
    value: 'en',
  },

  {
    label: $i18n.get({ id: 'Spanish.four_px', dm: '西班牙语' }),
    value: 'es',
  },

  {
    label: $i18n.get({ id: 'Italian.four_px', dm: '意大利文' }),
    value: 'it',
  },

  {
    label: $i18n.get({ id: 'Russian.four_px', dm: '俄罗斯文' }),
    value: 'ru',
  },

  {
    label: $i18n.get({ id: 'Japanese.four_px', dm: '日文' }),
    value: 'ja',
  },

  {
    label: $i18n.get({ id: 'Arabic', dm: '阿拉伯语' }),
    value: 'ar',
  },

  {
    label: $i18n.get({ id: 'French', dm: '法语' }),
    value: 'fr',
  },

  {
    label: $i18n.get({ id: 'Korean', dm: '韩语' }),
    value: 'ko',
  },
];

export const FOOT_WEIGHT_ACTION = [
  {
    label: $i18n.get({ id: 'PendingApproval', dm: '待审批' }),
    value: 'ko',
  },
  {
    label: $i18n.get({ id: 'ToBeChecked', dm: '待查验' }),
    value: 'ko2',
  },
  {
    label: $i18n.get({ id: 'InInspection', dm: '查验中' }),
    value: 'ko23',
  },
  {
    label: $i18n.get({ id: 'Closed.four_px', dm: '已完结' }),
    value: 'ko23',
  },
];

export const SKUREVIEWDETAIL_STATUS = [
  {
    label: $i18n.get({ id: 'PendingApproval', dm: '待审批' }),
    value: 'SA',
  },
  {
    label: $i18n.get({ id: 'ToBeChecked', dm: '待查验' }),
    value: 'SN',
  },
  {
    label: $i18n.get({ id: 'InInspection', dm: '查验中' }),
    value: 'SH',
  },
  {
    label: $i18n.get({ id: 'Closed.four_px', dm: '已完结' }),
    value: 'SF',
  },
  {
    label: $i18n.get({ id: 'ApprovalCompleted', dm: '审批完结' }),
    value: 'AC',
  },
  {
    label: $i18n.get({ id: 'ManualCompletion', dm: '手动完结' }),
    value: 'MC',
  },
];

export const BOHUI_STATUS_LIST = [
  {
    label: $i18n.get({
      id: 'PhotoShootingIsNotStandardLength_166855637',
      dm: '照片拍摄不规范，未完整记录长/宽/高尺寸、重量、SKU信息',
    }),
    value: 'PS',
  },
  {
    label: $i18n.get({ id: 'ThePhotoIsNotClearAndCannotBe', dm: '照片不清晰，无法准确读数' }),
    value: 'PC',
  },
  {
    label: $i18n.get({ id: 'MeasurementGoodsDoNotMatchSystem_1295755916', dm: '测量商品与系统商品不符' }),
    value: 'MS',
  },
  {
    label: $i18n.get({
      id: 'PhotoReadingDoesNotMatchUploaded_1366430925',
      dm: '照片读数与上传数据不符（重量读数错误、手输错误）',
    }),
    value: 'RW',
  },
  {
    label: $i18n.get({
      id: 'PhotoReadingDoesNotMatchUploaded_1697393756',
      dm: '照片读数与上传数据不符（尺寸读数错误、手输错误）',
    }),
    value: 'RS',
  },
  {
    label: $i18n.get({ id: 'MeasurementMethodErrordoesNotCom_1719474121', dm: '测量方式错误-不符合测量规则' }),
    value: 'MME',
  },
  {
    label: $i18n.get({ id: '31255237310418944.CNTM', dm: '其他' }),
    value: 'OTHER',
  },
];

export const PACKAGE_SOURCE = [
  {
    label: $i18n.get({ id: 'GeneralCainiao', dm: '菜鸟通用' }),
    value: 'CG',
  },
  {
    label: $i18n.get({ id: 'CainiaoCustomization', dm: '菜鸟定制' }),
    value: 'CC',
  },
  {
    label: $i18n.get({ id: 'MerchantsSelfpurchase', dm: '商家自采' }),
    value: 'CS',
  },
];

/**
 * @description 是/否/可选
 */
export const Y_N_OPTIONS = [
  {
    label: $i18n.get({ id: 'Is.four_px', dm: '是' }),
    value: 'Y',
  },

  {
    label: $i18n.get({ id: 'F.No.four_px', dm: '否' }),
    value: 'N',
  },
  {
    label: $i18n.get({ id: 'Optional', dm: '可选' }),
    value: 'O',
  },
];

const BATTERY_CONFIG = [
  {
    label: $i18n.get({ id: 'ExternalPI966', dm: '外置PI966' }),
    value: 'EB',
  },
  {
    label: $i18n.get({ id: 'PurePI965', dm: '纯PI965' }),
    value: 'PB',
  },
  {
    label: $i18n.get({ id: 'BuiltinPI967', dm: '内置PI967' }),
    value: 'IB',
  },
  {
    label: $i18n.get({ id: 'QT.Other.four_px', dm: '其他' }),
    value: 'NB',
  },
  {
    label: $i18n.get({ id: 'ExternalLithiumMetalPI969', dm: '外置锂金属PI969' }),
    value: 'EL',
  },
  {
    label: $i18n.get({ id: 'BuiltinLithiumMetalPI970', dm: '内置锂金属PI970' }),
    value: 'BL',
  },
  {
    label: $i18n.get({ id: 'PurePI968', dm: '纯PI968' }),
    value: 'PB968',
  },
];

const BATTERY_TYPE = [
  {
    label: $i18n.get({ id: 'LithiumBattery', dm: '锂电池' }),
    value: 'LI',
  },
  {
    label: $i18n.get({ id: 'LithiumMetalBattery', dm: '锂金属电池' }),
    value: 'LM',
  },
  {
    label: $i18n.get({ id: 'LithiumionBattery', dm: '锂离子电池' }),
    value: 'LS',
  },
  {
    label: $i18n.get({ id: 'MagnesiumHydrogenBattery', dm: '镁氢电池' }),
    value: 'NI',
  },
  {
    label: $i18n.get({ id: 'DryBattery', dm: '干电池' }),
    value: 'DR',
  },
  {
    label: $i18n.get({ id: 'NonlithiumButtonBattery', dm: '非锂电池类纽扣电池' }),
    value: 'BU',
  },
  {
    label: $i18n.get({ id: 'QT.Other.four_px', dm: '其他' }),
    value: 'OT',
  },
];

const BATTERY_SPEC = [
  {
    label: $i18n.get({ id: 'BatteryPack', dm: '电池组' }),
    value: 'BP',
  },
  {
    label: $i18n.get({ id: 'BatteryCore', dm: '电池芯' }),
    value: 'BC',
  },
];

export {
  CHECK_REASON,
  CHECK_REASON_SKU,
  CONTAINER_OPERATE_TYPE,
  GOODS_CONTAINER_TYPE,
  Y_N,
  TRUE_FALSE,
  VIRTUAL_LOC_ADJ_REASON_LIST,
  STOCK_QUALITYS,
  ADJUSTYPE,
  STOCKTYPE,
  INVENORYNUMTYPE,
  STOCK_DIFF_MANAGE,
  STOCK_SEARCH_ADJUST_TYPE,
  STOCK_SEARCH_ADJUST_ADD_RESON,
  STOCK_SEARCH_ADJUST_SUB_RMA_RESON,
  STOCK_SEARCH_ADJUST_SUB_RESON,
  STOCK_DIFF_EXCEPTE_TYPE,
  DIFF_SKU_TYPE,
  RETRNSKU_LIST_CONST,
  ATTRIBUTELIST,
  DONGXIAOLVLIST,
  TWINLIST,
  DTREECARGOTYPES,
  CHECKVIEWLISTPANDA,
  GOODS_CARGO_TYPE,
  STORAGE_TYPE,
  CONTAINWENUMTYPE_LIST,
  GOODS_TYPE,
  QUALITY_TYPE,
  SKU_TYPE,
  OPT_TYPE,
  PACKAGE_OPT_TYPE,
  ABNORMAL_LOCATION_INVENTORY_BREAKDOWN_TYPE,
  PACKAGE_LAN_TYPE,
  DIFFTYPE,
  INVDIFFERENTJOBSTATUS,
  OPERATIONSTEP,
  TYPE,
  DIFFERENTJOBBUSINESSTYPE,
  BATTERY_CONFIG,
  BATTERY_TYPE,
  BATTERY_SPEC,
};
